// @flow
import withNotifications from "@fas/ui-framework/lib/services/notifications";
import { Notifications } from "@fas/ui-core";

// $FlowFixMe
export default withNotifications(Notifications);
